import { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { filterByLocale, promoChecker } from "@helpers/miscHelpers"
import { toThemeKey } from "@helpers/campaignThemes"

// Returns the first active Dato promotion (by position) with its campaign theme
const useActivePromotion = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        buildTime
      }
      promotions: allDatoCmsPromotion(sort: { order: ASC, fields: position }) {
        nodes {
          startDate
          endDate
          name
          id
          locales
          productTheme
          badge {
            url
          }
        }
      }
    }
  `)

  // Render with the build time first so the page matches the static HTML,
  // then switch to the visitor's clock so promotions start and end on time
  const [now, setNow] = useState(() => new Date(data.site.buildTime))
  useEffect(() => setNow(new Date()), [])

  const promotion = filterByLocale(data.promotions.nodes).find(promo =>
    promoChecker(promo.startDate, promo.endDate, promo.locales, now)
  )

  return promotion
    ? { ...promotion, theme: toThemeKey(promotion.productTheme) }
    : null
}

export default useActivePromotion
